<template>
  <div class="pdfBG">
    <img class="image" :src="src"/>
  </div>
</template>

<script>


export default {
    name:'yuelanImage',
    data(){
        return {
            src:''
        }
    },
    created(){
      let url = localStorage.getItem("src");
      this.src =url
    },
    methods:{
    },
}
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.pdfBG{
    width: 100%;

    // height: 100%;
    background-color: #f3f4f6;
    display: inline-block;
    justify-content: center;
    // align-content: center;
    // justify-items: center;
    flex-direction: row;

}
.image{
    object-fit: cover;
    max-width: 100%;
    max-height: 100%;
}
</style>